import { Helmet } from 'react-helmet';// eslint-disable-line
import { Button, Input, InputLabel, TextField, Typography } from '@mui/material';
import * as React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { loginUser, loginSelector, clearState, isLogged } from '../store/slices/loginSlice';
import { useEffect, useState } from "react";
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { colors } from '../styles/colors';
import { ffetch, axios }  from '../api/customHttp';
import { useLocalNotifications } from 'components/Events';

const color1 = "#c2ded3";
const color2 = "#b9d9e6";

// храним в редаксе токен (и ещё сделать токен для продления в сторадже)
const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showNotification } = useLocalNotifications();

  const { isFetching, isSuccess, isError, errorMessage, errType } = useSelector(
    loginSelector
  );


  const [searchParams] = useSearchParams();
  // Получаем URL для редиректа из query параметров
  const redirectParam = searchParams.get('redirect');
  
  // Если есть redirect параметр, сохраняем его
  useEffect(() => {
    if (redirectParam) {
      // Сохраняем в sessionStorage или state
      sessionStorage.setItem('redirectAfterLogin', redirectParam);
    }
  }, [redirectParam]);

  // // Проверяем авторизацию при загрузке
  // useEffect(() => {
  //   console.log("Login компонент загружен, проверяем авторизацию...");
  //   dispatch(isLogged());
  // }, [dispatch]);

  useEffect(() => {
    console.log("Состояние авторизации изменилось:", { 
      isFetching, 
      isSuccess, 
      isError,
      errorMessage,
      errType
    });
    
    if (isError) {
      console.log("Ошибка авторизации:", errorMessage, "Тип:", errType);
      switch (errType){
        case "coreError": {
          showNotification({
            id: 'lerr', 
            type: 'error', 
            message: 'Ошибка авторизации' 
          });
          break;
        }
        case "dataError": {
          showNotification({
            id: 'lerr', 
            type: 'error', 
            message: 'Неверный логин или пароль' 
          });
          break;
        }
        default: {
          // Ошибка проверки авторизации (isLogged)
          // Не показываем уведомление, просто остаемся на странице логина
        }
      }
      dispatch(clearState());
    }

    if (isSuccess && !isFetching) {
      console.log("Авторизация успешна");
      
      // Получаем сохраненный URL для редиректа
      const redirectUrl = sessionStorage.getItem('redirectAfterLogin') || '/home';
      
      // Очищаем сохраненный URL
      sessionStorage.removeItem('redirectAfterLogin');
      
      console.log("Переходим на:", redirectUrl);
      navigate(redirectUrl, { replace: true });
    }
  }, [isError, isSuccess, isFetching, navigate, dispatch]);

  const onSubmit = (data) => {
    console.log("Попытка входа:", data);
    dispatch(loginUser(data));
  };

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const { role, user_id, company_id } = useSelector(
    loginSelector
  );
  console.log("test", role, user_id, company_id)

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSubmit({ login: username, password: password });
    }
  };
  
  if (isFetching) {
    return (
      <div style={{ position: 'fixed', background: `linear-gradient(90deg, ${color1}, ${color2})`, width: '100%', height: '100%' }}>
        <div style={{position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
          <Typography style={{ textAlign: "center", color: "white" }} variant="h3">
            Проверка авторизации...
          </Typography>
        </div>  
      </div>
    );
  }

  if (!isSuccess) {
    return (
      <>
        <Helmet>
          <title>Login</title>
        </Helmet>
        <div style={{ position: 'fixed', background: `linear-gradient(90deg, ${color1}, ${color2})`, width: '100%', height: '100%' }}>
          <div style={{position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
            <div style={{ paddingTop: '20px', paddingBottom: '20px', background: "#ffffff", display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignContent: "center", flexWrap: 'nowrap', minWidth: '200px', borderRadius: '15px' }}>
              <Typography style={{ textAlign: "center" }} color="text.secondary" variant="h2">Вход</Typography>
              {isError ? (
                <Typography color="red" variant="body1" >
                  {errorMessage}
                </Typography>) : (<></>)
              }
              <div style={{ width: '100%', paddingLeft: '15%', paddingRight: '15%', marginTop: '20px', marginBottom: '20px' }}>
                <TextField  inputProps={{ maxLength: 80 }} id="login" label="логин" variant="outlined" style={{width: '100%', borderRadius: '18px', marginBottom: '20px'}} value={username} onChange={(e) => {setUsername(e.target.value);}}/>
                <TextField id="password" label="пароль" variant="outlined" style={{width: '100%', borderRadius: '18px'}} value={password} onChange={(e) => {setPassword(e.target.value);}}
                  type={showPassword ? 'text' : 'password'}
                  onKeyDown={handleKeyDown}
                  inputProps={{ maxLength: 80 }}
                  InputProps={{
                    endAdornment:(
                      <div>
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </div>
                    )
                    }}
                />
              </div>
              {!isFetching ? (
                <>
                  {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginBottom: '10px' }}>
                      <a href="https://example.com" style={{ textTransform: 'none', textDecoration: 'underline', color: colors.elements }}>Не помню пароль</a>
                  </div> */}
                  <div style={{ width: '100%', paddingLeft: '25%', paddingRight: '25%' }}>
                    <Button onClick={() => onSubmit({ login: username, password: password })} onKeyDown={handleKeyDown} style={{ width: '100%', maxHeight: '40px', background: colors.elements, color: 'white', fontWeight: 'bold' }}>Войти</Button>
                  </div>
                </>
              ) : (
                <LoadingButton loading loadingPosition="start" startIcon={<SaveIcon />} variant="outlined"> Loading </LoadingButton>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  // Если isSuccess = true, но еще не произошел редирект
  return (
    <div style={{ position: 'fixed', background: `linear-gradient(90deg, ${color1}, ${color2})`, width: '100%', height: '100%' }}>
      <div style={{position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
        <Typography style={{ textAlign: "center", color: "white" }} variant="h3">
          Перенаправление...
        </Typography>
      </div>
    </div>
  );
};


export default Login;